'use client'

import { useEffect } from 'react'

import SearchPageContainer from 'pageContainers/SearchPage'
import { useAppDispatch } from 'store/hooks'
import { saveGamesProductsFromCategories } from 'store/modules/games/actions'

import type { GameProduct, SwimlaneCategory } from '@patrianna/shared-patrianna-types/store/GameModule'

export default function Search(props: {
  categories: SwimlaneCategory[]
  topGames: SwimlaneCategory['products']
  layout: string
}) {
  const { categories, layout } = props
  const dispatch = useAppDispatch()
  const topGames = props.topGames as GameProduct[] // TODO: make right typification

  useEffect(() => {
    if (props.categories?.length) {
      dispatch(saveGamesProductsFromCategories(props.categories))
    }
    // eslint-disable-next-line
  }, [])

  return <SearchPageContainer topGames={topGames} categories={categories} layout={layout} />
}
